import React from "react";
import ReactDOM from "react-dom";

// import * as Sentry from "@sentry/react";

import App from "./App";
import OrganizationThemeContext from "./context/OrganizationThemeContext";
import { FontSizeProvider } from "./context/FontSizeContext";

// Sentry.init({
//   dsn: "https://f0b24e13c70f44eeb35f337a1efdd974@o1336474.ingest.sentry.io/6621512",
//   tracesSampleRate: 1.0,
// });

ReactDOM.render(
  <OrganizationThemeContext>
    <FontSizeProvider>
      <App />
    </FontSizeProvider>
  </OrganizationThemeContext>,
  document.getElementById("root")
);
